module.exports = __webpack_public_path__ + "media/contact/Polygon 3-4fb4bfdb.png";